<template>
  <div>
    <button
      class="m-aside-left-close m-aside-left-close--skin-light d-print-none"
      id="m_aside_left_close_btn"
    >
      <i class="la la-close"></i>
    </button>
    <div
      id="m_aside_left"
      class="m-grid__item m-aside-left m-aside-left--skin-light d-print-none"
    >
      <div
        id="m_ver_menu"
        class="m-aside-menu m-aside-menu--skin-light m-aside-menu--submenu-skin-light"
        m-menu-vertical="1"
        m-menu-scrollable="1"
        m-menu-dropdown-timeout="500"
      >
        <ul class="m-menu__nav">
          <router-link
            tag="li"
            to="/"
            class="m-menu__item"
            active-class="m-menu__item--active"
            exact
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-analytics"></i
              ><span class="m-menu__link-text">Dashboard</span>
            </a>
          </router-link>

          <li class="m-menu__section">
            <h4 class="m-menu__section-text">Cadastros</h4>
            <i class="m-menu__section-icon flaticon-more-v2"></i>
          </li>

          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{ 'm-menu__item--open': subIsActive('/customer') }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-user-tie"></i
              ><span class="m-menu__link-text">Clientes</span>
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/customers"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-list"></i
                    ><span class="m-menu__link-text">Listar</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/customers/groups"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-users"></i
                    ><span class="m-menu__link-text">Grupos</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/customers/contracts"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-pen-nib"></i
                    ><span class="m-menu__link-text">Contratos</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/customers/contract/plans"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-money-check-edit"></i
                    ><span class="m-menu__link-text">Contratos (Planos)</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/customers/pocs"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-parking"></i
                    ><span class="m-menu__link-text">POCs</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/customers/external-check"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i
                      class="m-menu__link-icon far fa-exclamation-triangle"
                    ></i
                    ><span class="m-menu__link-text">Não sincronizados</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/customers/proposals"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-pencil"></i
                    ><span class="m-menu__link-text">Propostas</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <router-link
            tag="li"
            to="/companies"
            class="m-menu__item"
            active-class="m-menu__item--active"
            exact
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-briefcase"></i
              ><span class="m-menu__link-text">Carteiras</span>
            </a>
          </router-link>

          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{ 'm-menu__item--open': subIsActive('/discounts') }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-funnel-dollar"></i
              ><span class="m-menu__link-text">Descontos</span>
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/discounts"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-list"></i
                    ><span class="m-menu__link-text">Cadastrados</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/discounts/applied"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-check"></i
                    ><span class="m-menu__link-text">Aplicados</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{
              'm-menu__item--open': subIsActive(
                '/discount_and_addition_services'
              ),
            }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-funnel-dollar"></i
              ><span class="m-menu__link-text"
                >Descontos e Acréscimos por serviço</span
              >
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/discount_and_addition_services"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-list"></i
                    ><span class="m-menu__link-text">Cadastrados</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{ 'm-menu__item--open': subIsActive('/bonus') }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-gift"></i
              ><span class="m-menu__link-text">Bonificação</span>
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/bonus"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-list"></i
                    ><span class="m-menu__link-text">Listar</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{ 'm-menu__item--open': subIsActive('/plans') }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-list-alt"></i
              ><span class="m-menu__link-text">Planos</span>
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/plans"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-list"></i
                    ><span class="m-menu__link-text">Listar</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{ 'm-menu__item--open': subIsActive('/users') }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-users"></i
              ><span class="m-menu__link-text">Controle de Acesso</span>
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/users"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-list"></i
                    ><span class="m-menu__link-text">Usuários</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/users/roles"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-id-badge"></i
                    ><span class="m-menu__link-text">Perfis de Acesso</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  to="/users/scopes"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-address-card"></i
                    ><span class="m-menu__link-text">Escopos do Sistema</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>

          <li class="m-menu__section">
            <h4 class="m-menu__section-text">Faturas</h4>
            <i class="m-menu__section-icon flaticon-more-v2"></i>
          </li>

          <router-link
            tag="li"
            to="/invoices"
            class="m-menu__item"
            active-class="m-menu__item--active"
            exact
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-clipboard-list-check"></i
              ><span class="m-menu__link-text">Consumo</span>
            </a>
          </router-link>

          <router-link
            tag="li"
            to="/invoices/generate"
            class="m-menu__item"
            active-class="m-menu__item--active"
            exact
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-abacus"></i
              ><span class="m-menu__link-text">Gerar Faturas</span>
            </a>
          </router-link>

          <li
            class="m-menu__item m-menu__item--submenu m-menu__item--rel"
            :class="{ 'm-menu__item--open': subIsActive('/customer') }"
            data-menu-submenu-toggle="click"
            aria-haspopup="true"
          >
            <a href="#" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon far fa-ballot"></i
              ><span class="m-menu__link-text">Faturas Parciais</span>
              <i class="m-menu__hor-arrow la la-angle-down"></i>
              <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div
              class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left"
            >
              <span class="m-menu__arrow m-menu__arrow--adjust"></span>
              <ul class="m-menu__subnav">
                <router-link
                  tag="li"
                  to="/singleinvoices"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i
                      class="m-menu__link-icon far fa-clipboard-list-check"
                    ></i
                    ><span class="m-menu__link-text">Consumos Parciais</span>
                  </a>
                </router-link>

                <router-link
                  tag="li"
                  to="/singleinvoice/generate"
                  class="m-menu__item"
                  active-class="m-menu__item--active"
                  exact
                >
                  <a href class="m-menu__link">
                    <span class="m-menu__item-here"></span
                    ><i class="m-menu__link-icon far fa-abacus"></i
                    ><span class="m-menu__link-text">Gerar Fatura Parcial</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>

          <router-link
            tag="li"
            to="/pendinginvoices"
            class="m-menu__item"
            active-class="m-menu__item--active"
            exact
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-hourglass-half"></i
              ><span class="m-menu__link-text">Faturas pendentes</span>
            </a>
          </router-link>

          <li class="m-menu__section">
            <h4 class="m-menu__section-text">Relatórios</h4>
            <i class="m-menu__section-icon flaticon-more-v2"></i>
          </li>

          <router-link
            tag="li"
            to="/reports/invoice/company"
            class="m-menu__item"
            active-class="m-menu__item--active"
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-file-invoice-dollar"></i
              ><span class="m-menu__link-text">Fatura por Carteira</span>
            </a>
          </router-link>

          <router-link
            tag="li"
            to="/reports/general"
            class="m-menu__item"
            active-class="m-menu__item--active"
          >
            <a href class="m-menu__link">
              <span class="m-menu__item-here"></span
              ><i class="m-menu__link-icon far fa-file-invoice-dollar"></i
              ><span class="m-menu__link-text">Gerar Relatório</span>
            </a>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { allowedRoutes } from '@/constants';

export default {
  name: 'Leftbar',
  data() {
    return {
      allowedRoutes,
      allowedMenuItems: {
        home: false,
        users: false,
        companies: false,
      },
    };
  },
  computed: mapState(['user', 'userRole']),
  created() {
    this.setVisibleMenuItems();
  },
  watch: {
    userRole() {
      this.setVisibleMenuItems();
    },
  },
  methods: {
    setVisibleMenuItems() {
      this.allowedMenuItems = {
        home: false,
        users: false,
        companies: false,
      };

      (this.allowedRoutes[this.userRole] || []).forEach((route) => {
        this.$set(this.allowedMenuItems, route, true);
      });
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(
        (path) => this.$route.path.indexOf(path) === 0 // current path starts with this path string
      );
    },
  },
};
</script>

<style></style>
